"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tabsTheme = void 0;
var _designTokens = require("@smartsheet/design-tokens");
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
var _colors = require("../../constants/colors");
var _spacing = require("../../constants/spacing");
const tabsTheme = (0, _sdsThemeInternal.themed)({
  canvas: {
    textColor: (0, _designTokensReact.color)("color--text--slate--strong"),
    underlineColor: (0, _designTokensReact.color)("color--border--slate--weakest"),
    underlineHoverColor: {
      "lodestar-light": (0, _designTokensReact.color)("color--border--slate--strong"),
      "ursa-light": (0, _designTokensReact.color)("color--border--slate--weaker")
    },
    activeTextColor: {
      "lodestar-light": (0, _designTokensReact.color)("color--text--slate--strong"),
      "ursa-light": `var(--sds--link--color--rest, ${(0, _designTokensReact.color)("color--text--slate--strong")})`
    }
  },
  "work-surface": {
    textColor: (0, _designTokensReact.color)("color--text--neutral--default"),
    underlineColor: (0, _designTokensReact.color)("color--border--neutral--weakest"),
    underlineHoverColor: {
      "lodestar-light": (0, _designTokensReact.color)("color--border--neutral--strong"),
      "ursa-light": (0, _designTokensReact.color)("color--border--neutral--weaker")
    },
    activeTextColor: {
      "lodestar-light": (0, _designTokensReact.color)("color--text--neutral--default"),
      "ursa-light": `var(--sds--link--color--rest, ${(0, _designTokensReact.color)("color--text--neutral--default")})`
    }
  },
  selectedTextColor: {
    "lodestar-light": (0, _designTokensReact.color)("color--text--neutral--strong"),
    "ursa-light": (0, _designTokensReact.color)("color--text--primary--default")
  },
  disabledTextColor: (0, _designTokensReact.color)("color--text--neutral--weaker"),
  underlineHeight: {
    default: {
      "lodestar-light": "2px",
      "ursa-light": "1px"
    },
    active: {
      "lodestar-light": "2px",
      "ursa-light": "3px"
    }
  },
  underlineSelectedColor: {
    "lodestar-light": _colors.buttonPrimary,
    "ursa-light": (0, _designTokensReact.color)("color--border--primary--default")
  },
  underlineAnimation: {
    "lodestar-light": "",
    "ursa-light": _designTokens.motion.easing.default
  },
  font: {
    weight: {
      "lodestar-light": "600",
      "ursa-light": "500"
    },
    lineHeight: "18px"
  },
  containerHeight: {
    "lodestar-light": `${_spacing.sizes.large}px`,
    "ursa-light": "36px"
  },
  focusRingRadius: {
    "lodestar-light": "4px",
    "ursa-light": 0
  },
  focusRingGap: {
    "lodestar-light": 2,
    "ursa-light": 8
  },
  focusRingRadiusOverride: {
    "lodestar-light": "0",
    "ursa-light": "8px"
  },
  focusRingInsetOverride: {
    "lodestar-light": "",
    "ursa-light": "0px"
  },
  tabMarginLeft: {
    "lodestar-light": `${_spacing.sizes.xLarge}px`,
    "ursa-light": `${_spacing.sizes.large}px`
  }
});
exports.tabsTheme = tabsTheme;
//# sourceMappingURL=tabsTheme.js.map